import React, { useEffect } from 'react';
import { TextInput, required } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { validateSlug } from 'utils/custom-validations';

const shortNameToSlug = (shortName: string): string =>
  shortName?.toLowerCase().split(' ').join('_') || '';

const SlugInput = () => {
  const { setValue, watch } = useFormContext();
  const shortName = watch('short_name');

  useEffect(() => {
    setValue('slug', shortNameToSlug(shortName));
  }, [shortName]);

  return (
    <TextInput label="Slug" source="slug" validate={[required(), validateSlug]} />
  );
};

export default SlugInput;
